import React, { useState, useMemo } from 'react';

const SERVICES = [
  { id: 'ai',      label: '🤖 AI Agent / LLM',        base: 150000, perWeek: 25000 },
  { id: 'cloud',   label: '☁️ Cloud / Azure Setup',    base: 80000,  perWeek: 15000 },
  { id: 'web',     label: '🌐 Web App (React/Next)',    base: 60000,  perWeek: 12000 },
  { id: 'mobile',  label: '📱 Mobile App (Flutter)',    base: 90000,  perWeek: 18000 },
  { id: 'backend', label: '🔧 .NET API / Backend',      base: 50000,  perWeek: 10000 },
  { id: 'devops',  label: '🔐 DevSecOps / CI-CD',      base: 40000,  perWeek: 8000  },
];

const COMPLEXITY = [
  { id: 'simple', label: 'Simple',   mult: 1.0 },
  { id: 'medium', label: 'Medium',   mult: 1.6 },
  { id: 'complex',label: 'Complex',  mult: 2.5 },
];


function fmt(n) {
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  return `₹${(n / 1000).toFixed(0)}K`;
}

export default function ProjectCalculator() {
  const [service, setService]     = useState('web');
  const [complexity, setComplexity] = useState('medium');
  const [weeks, setWeeks]         = useState(6);
  const [open, setOpen]           = useState(false);

  const estimate = useMemo(() => {
    const svc = SERVICES.find(s => s.id === service);
    const cmp = COMPLEXITY.find(c => c.id === complexity);
    const total = (svc.base + svc.perWeek * weeks) * cmp.mult;
    return { low: Math.floor(total * 0.85), mid: Math.floor(total), high: Math.floor(total * 1.2) };
  }, [service, complexity, weeks]);

  return (
    <>
      {/* Floating trigger */}
      <button className="calc-trigger" onClick={() => setOpen(true)} aria-label="Open project cost calculator" title="Estimate project cost">
        🧮
        <span className="calc-trigger-label">Estimate Cost</span>
      </button>

      {/* Modal */}
      {open && (
        <div className="calc-overlay" onClick={e => e.target === e.currentTarget && setOpen(false)}>
          <div className="calc-modal" role="dialog" aria-label="Project cost calculator">
            <button className="calc-close" onClick={() => setOpen(false)} aria-label="Close calculator">✕</button>
            <div className="calc-header">
              <div className="calc-title">🧮 Project Cost Estimator</div>
              <p className="calc-subtitle">Get an instant budget estimate for your project</p>
            </div>

            <div className="calc-body">
              {/* Service */}
              <div className="calc-field">
                <label className="calc-label">Service Type</label>
                <div className="calc-opts">
                  {SERVICES.map(s => (
                    <button key={s.id} className={`calc-opt ${service === s.id ? 'on' : ''}`} onClick={() => setService(s.id)}>
                      {s.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Complexity */}
              <div className="calc-field">
                <label className="calc-label">Complexity</label>
                <div className="calc-opts horiz">
                  {COMPLEXITY.map(c => (
                    <button key={c.id} className={`calc-opt ${complexity === c.id ? 'on' : ''}`} onClick={() => setComplexity(c.id)}>
                      {c.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Duration */}
              <div className="calc-field">
                <label className="calc-label">Duration: <strong>{weeks} weeks</strong></label>
                <input type="range" min={2} max={16} step={2} value={weeks} onChange={e => setWeeks(+e.target.value)} className="calc-range"/>
                <div className="calc-range-labels">
                  <span>2w</span><span>4w</span><span>6w</span><span>8w</span><span>12w</span><span>16w</span>
                </div>
              </div>

              {/* Estimate */}
              <div className="calc-result">
                <div className="calc-res-label">Estimated Budget Range</div>
                <div className="calc-range-vals">
                  <div className="crv low"><div className="crv-n">{fmt(estimate.low)}</div><div className="crv-l">Minimum</div></div>
                  <div className="crv mid"><div className="crv-n">{fmt(estimate.mid)}</div><div className="crv-l">Typical</div></div>
                  <div className="crv high"><div className="crv-n">{fmt(estimate.high)}</div><div className="crv-l">Maximum</div></div>
                </div>
                <p className="calc-note">* Estimates vary based on specific requirements, integrations, and team size. Contact us for a precise quote.</p>
              </div>

              <div className="calc-ctas">
                <a href="https://wa.me/918123629993?text=I used the Project Calculator — my estimate is for a {service} project. Can we discuss?" target="_blank" rel="noopener noreferrer" className="btn btn-green" style={{width:'100%',justifyContent:'center'}}>
                  💬 Get Exact Quote on WhatsApp
                </a>
                <button className="btn btn-outline-g" style={{width:'100%',justifyContent:'center'}} onClick={() => {setOpen(false); document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'})}}>
                  📋 Fill Contact Form
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
